import React from 'react';
import SearchWidget from './SearchWidget';
const Hero = () => {
  return <div className="relative bg-blue-800 overflow-hidden" data-id="element-38">
      {/* Background image */}
      <div className="absolute inset-0" data-id="element-39">
        <img src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2073&q=80" alt="Beach destination" className="w-full h-full object-cover" data-id="element-40" />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900 via-blue-900/70 to-transparent mix-blend-multiply" data-id="element-41" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32" data-id="element-42">
        <div className="md:w-3/4 lg:w-1/2" data-id="element-43">
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-white mb-6" data-id="element-44">
            Discover Your Perfect Journey
          </h1>
          <p className="text-xl text-blue-100 mb-8" data-id="element-45">
            Book flights, hotels, and vacation packages with ease. Enjoy
            exclusive deals and seamless booking experience.
          </p>
        </div>
        <div className="mt-8" data-id="element-46">
          <SearchWidget data-id="element-47" />
        </div>
      </div>
    </div>;
};
export default Hero;